import React, { createContext, useState, useContext } from "react";

const ActiveContext = createContext(true);

export const useActiveContext = () => useContext(ActiveContext);

export const ContextProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <ActiveContext.Provider value={{ isActive, setIsActive }}>
      {children}
    </ActiveContext.Provider>
  );
};

export default ContextProvider;
